import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import authentication from 'react-azure-b2c';
import AppConsts from "../../utils/appconst";

const { REACT_APP_BASE_URL } = (window as any)._env_;

const api = () => {
  const defaultOptions = {
    baseURL: REACT_APP_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    }
  };

  // Create instance
  let instance = axios.create(defaultOptions);

  // Set the AUTH token for any request
  instance.interceptors.request.use((config: AxiosRequestConfig) => {
    const token = authentication.getAccessToken().accessToken;

    if(!!config.headers) {
      config.headers.Authorization =  token ? `Bearer ${token}` : '';
      config.headers['Access-Control-Max-Age'] = 0;
    }

    return config;
  });

  // return response
  instance.interceptors.response.use((response: AxiosResponse) => response)

  return instance;
};

export default api();
